import { defineMessages } from "react-intl";
const messages = defineMessages({
    demoFormError: {
        id: "app.aiDiscoverability.demo.error.text",
        defaultMessage: "Unable to access demo. Please try again.",
    },
    demoButton: {
        id: "app.aiDiscoverability.demo.button.text",
        defaultMessage: "Access Demo",
    },
    demoEmailLabel: {
        id: "app.aiDiscoverability.demo.email.label.text",
        defaultMessage: "Business Email",
    },
    demoNameLabel: {
        id: "app.aiDiscoverability.demo.name.label.text",
        defaultMessage: "Name",
    },
    demoCommunityNameLabel: {
        id: "app.aiDiscoverability.demo.communityName.label.text",
        defaultMessage: "Company Name",
    },
    demoEmailPlaceholder: {
        id: "app.aiDiscoverability.demo.email.placeholder.text",
        defaultMessage: "your@company.com",
    },
    demoNamePlaceholder: {
        id: "app.aiDiscoverability.demo.name.placeholder.text",
        defaultMessage: "Your Full Name",
    },
    demoCommunityNamePlaceholder: {
        id: "app.aiDiscoverability.demo.communityName.placeholder.text",
        defaultMessage: "Your Company Name",
    },
    demoEmailError: {
        id: "app.aiDiscoverability.demo.email.error.text",
        defaultMessage: "Please enter a valid business email",
    },
    demoEmailRequired: {
        id: "app.aiDiscoverability.demo.email.required.text",
        defaultMessage: "Email is required",
    },
    demoNameRequired: {
        id: "app.aiDiscoverability.demo.name.required.text",
        defaultMessage: "Name is required",
    },
    demoCommunityNameRequired: {
        id: "app.aiDiscoverability.demo.communityName.required.text",
        defaultMessage: "Community name is required",
    },
    demoEmailPersonal: {
        id: "app.aiDiscoverability.demo.email.personal.text",
        defaultMessage: "Please use a business email address",
    },
});
export default messages;
